// How long a toast stays — the app's one <ToastContainer> (index.js) reads it.
// A gym's Web App look (Branded App → Web App → Popups) sets it from the owner
// dashboard; 5000 ms is react-toastify's own default, i.e. today's behaviour.
import { useSyncExternalStore } from "react";

const DEFAULT_MS = 5000;
let ms = DEFAULT_MS;
const subs = new Set();

export const getToastMs = () => ms;
export function setToastMs(value) {
  const next = Number(value) > 0 ? Number(value) : DEFAULT_MS;
  if (next === ms) return;
  ms = next;
  subs.forEach((f) => f());
}
const subscribe = (f) => { subs.add(f); return () => subs.delete(f); };
export const useToastMs = () => useSyncExternalStore(subscribe, getToastMs, getToastMs);
